import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Modal, Spin } from 'antd';
import { FormProvider, useForm } from 'react-hook-form';

import { useUpdateSchoolFAQMutation } from '@/api/endpoints/schools/schoolSubjectionParams/FAQs';
import { DataSection, TextAreaField } from '@/shared/components';
import { useApiRequest } from '@/shared/hooks';

import { QUESTION_VALIDATION_SCHEMA } from '../../consts';
import type { IFAQItemData, TFormData } from '../../types';

import styles from './QuestionModals.module.scss';

type TProps = {
  schoolId: number;
  isModalOpen: boolean;
  handleCancel: VoidFunction;
  handleClearOperateItem: VoidFunction;
  itemToOperate: IFAQItemData;
};

export const EditQuestionModal = ({
  schoolId,
  isModalOpen,
  handleCancel,
  handleClearOperateItem,
  itemToOperate,
}: TProps) => {
  const [editQuestion, { isLoading: isQuestionUpdating }] = useUpdateSchoolFAQMutation();
  const sendApiRequest = useApiRequest();

  const methods = useForm<TFormData>({
    defaultValues: {
      question: itemToOperate ? itemToOperate.question : '',
      answer: itemToOperate ? itemToOperate.answer : '',
    },
    resolver: yupResolver(QUESTION_VALIDATION_SCHEMA),
  });

  const { handleSubmit } = methods;

  const handleSaveQuestion = handleSubmit(({ question, answer }) => {
    sendApiRequest({
      successMessage: 'Вопрос успешно изменён',
      apiRequestCallback: () =>
        editQuestion({
          questionId: itemToOperate.id,
          schoolId,
          data: {
            question,
            answer,
          },
        }),
      successCallback: () => {
        handleCancel();
        handleClearOperateItem();
      },
    });
  });

  return (
    <Modal
      width={600}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      centered
    >
      <Spin spinning={isQuestionUpdating}>
        <div className={styles.wrapper}>
          <FormProvider {...methods}>
            <p className={styles.title}>Изменение вопроса</p>
            <div className={styles['content-wrapper']}>
              <DataSection
                titleText="Вопрос"
                isTitleRequired
              >
                <TextAreaField
                  fieldName="question"
                  placeholder="Вопрос"
                />
              </DataSection>
              <DataSection
                titleText="Ответ"
                isTitleRequired
              >
                <TextAreaField
                  fieldName="answer"
                  placeholder="Ответ"
                />
              </DataSection>
            </div>
            <div className={styles['buttons-wrapper']}>
              <Button
                size="large"
                onClick={handleCancel}
                className={styles.button}
                type="dashed"
              >
                Отмена
              </Button>
              <Button
                size="large"
                onClick={handleSaveQuestion}
                type="primary"
                className={styles.button}
                disabled={isQuestionUpdating}
              >
                Сохранить
              </Button>
            </div>
          </FormProvider>
        </div>
      </Spin>
    </Modal>
  );
};
